import React from 'react';

import { Chip, ChipProps } from '@mui/material';

import { titleCase } from '~/utils/stringUtils';

const STATUS_COLOR_MAP: Record<string, ChipProps['color']> = {
  Available: 'warning',
  Activated: 'success',
};

function getStatusColor(status: string): ChipProps['color'] {
  return STATUS_COLOR_MAP[status] ?? 'error';
}

export default function EmployeeStatusCell({ status }: { status: string }) {
  if (!status) {
    return null;
  }
  const displayStatus = titleCase(status);
  return <Chip label={displayStatus} color={getStatusColor(displayStatus)} />;
}
